import { createClient } from '@supabase/supabase-js'
import { Database } from './types'

// Single shared client — Supabase handles connection pooling internally.
// Untyped until `supabase gen types` is run post-schema-apply; add <Database> generic then.
export const supabase = createClient<Database>(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  }
)
